const notFound = {
  error: "抱歉，你访问的页面不存在",
  backHome: "返回首页"
} 
export default notFound